'use client';

import { useId } from 'react';

const SIZES = {
  sm: { box: 'h-[42px] w-[42px] rounded-[10px]', svg: 22 },
  md: { box: 'h-12 w-12 rounded-xl', svg: 28 },
} as const;

export const BrandLogo = ({ size = 'md' }: { size?: keyof typeof SIZES }) => {
  const gradientId = useId();
  const { box, svg } = SIZES[size];
  return (
    <div
      className={`flex shrink-0 items-center justify-center border border-brand-teal/20 bg-linear-to-br from-brand-teal/12 to-brand-blue/12 ${box}`}
      aria-label="Techfusion logo"
    >
      <svg width={svg} height={svg} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="#46c0ba" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M2 17L12 22L22 17" stroke="#4365ad" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M2 12L12 17L22 12" stroke={`url(#${gradientId})`} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <defs>
          <linearGradient id={gradientId} x1="2" y1="12" x2="22" y2="12" gradientUnits="userSpaceOnUse">
            <stop stopColor="#46c0ba" />
            <stop offset="1" stopColor="#4365ad" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};

export const Brand = ({ size = 'md' }: { size?: keyof typeof SIZES }) => (
  <div className="flex items-center gap-3">
    <BrandLogo size={size} />
    <div>
      <div className="text-base font-bold leading-tight text-white">Techfusion</div>
      <div className="text-[0.7rem] font-normal uppercase tracking-[0.06em] text-brand-teal">Demos HUB</div>
    </div>
  </div>
);
